<ag-grid-angular
  class="ag-theme-unthemed h-full"
  [getContextMenuItems]="getContextMenuItems"
  [gridOptions]="state.gridOptions"
  [rowData]="state.treeNodes"
  (gridReady)="onGridReady($event)"
  (bodyScroll)="onGridScrolled($event)"
/>
